import React from 'react';

import ic_close from 'image/ic_close_b.svg';
import ic_write from 'image/ic_write.svg';

const DataList = (props) => {
  return (
    <li className="list-admin DataList">
      <div className="wrap-text">
        <p className="adminList-title">{props.data.title}</p>
        <ul className="wrap-info">
          {Object.keys(props.data).map(el => {
            if(el ===`id` || el === `images` || el === `timestamp`|| el === `title` || el === "files"){
              return "";
            }else{
              return  <li className={`info data-${props.lnb}`} key = {el}>
                        <p className={`info-contents data-${el} ${el==='category' ? `color-main`: ``}`}>{props.data[el]}</p>
                      </li>
            }
          })
				}
          
        </ul>
      </div>

      <ul className="btn-wrap">
        <img src={ic_write} alt="edit" onClick = {() => {props.handleEditClick(props.data.id)}}/>
        <img src={ic_close} alt="delete" onClick = {() => {props.handleDeleteClick(props.data.id)}}/>
      </ul>
    </li>
  );
}

export default DataList;